import React from 'react'
import { connect } from 'react-redux'
import { changePlanningTeam } from '../actions'
import Textbox from '../components/Textbox'

const PlanTeam = ({ teamId, teams, plans, user, changePlanningTeam }) => (
  <Textbox 
    title = {teams[teamId].name}
    titleClick = {() => changePlanningTeam(teamId) }
    text = {plans.planData[plans.selectedPlanId][teamId] && plans.planData[plans.selectedPlanId][teamId].plan !== "" ? 
        plans.planData[plans.selectedPlanId][teamId].plan
      :
        ' '
      }
    editable = {user.admin}
    editLink = {'/plan/edit/' + teamId}
  />
)

export default connect(
  state => ({
    teams: state.organization.teams,
    plans: state.plans,
    user: state.user
  }),
  { changePlanningTeam }
)(PlanTeam)



// WEBPACK FOOTER //
// ./src/components/PlanTeam.js